/*
TODO: convert to `a.Query` and then RIP OUT this code.
*/

import * as a from '@mitranim/js/all.mjs'
import * as ut from './util-text.mjs'

// Given a query, this returns the first available value for the key.
export function queryGet(query, key) {
  const value = a.laxStruct(query)[key]
  return a.isList(value) ? a.head(value) : value
}

export function queryValEncode(val) {return queryValEncodeBy(val, queryStrEncode)}
export function queryValDecode(val) {return queryValDecodeBy(val, queryStrDecode)}

// Tentative. The input value may be of any type. The output is either nil, a
// list of strings, or a single string.
export function queryValEncodeBy(val, fun) {
  a.reqFun(fun)
  const run = val => queryValEncodeFlatBy(val, fun)
  return a.isList(val) ? a.map(val, run) : run(val)
}

function queryValEncodeFlatBy(val, fun) {
  val = fun(val)
  return a.isNil(val) ? undefined : a.laxStr(val)
}

// Tentative. The input value must be either nil, a list of strings, or a single
// string. The output may be nil, a list of T, or a single T, as returned by
// the provided function.
export function queryValDecodeBy(val, fun) {
  a.reqFun(fun)
  return a.isList(val) ? a.map(val, fun) : fun(val)
}

// Tentative. Should be used via `queryValEncodeBy`.
export function queryStrEncode(val) {
  return a.isNil(val)
    ? undefined
    : ut.isPrintable(val)
    ? String(val)
    : a.jsonEncode(val)
}

// Tentative. Should be used via `queryValDecodeBy`.
export function queryStrDecode(val) {return ut.maybeJsonDecode(val)}

/*
Adapter for pre-existing code written for `querystring` quirks. TODO convert all
code to `a.Url`/`a.Query`, and remove this.
*/
export function urlQuery(val) {
  return a.mapDict(ut.toUrl(val).query.toDictAll(), simplifyQueryVals)
}

function simplifyQueryVals(vals) {
  return a.len(vals) === 1 ? a.head(vals) : vals
}
